import type { FormApi } from 'final-form';

import type { Currency } from '@swf/core/enums';
import type {
  GameStructure,
  HGCreateClubTournamentReply,
  HGGetClubTournStructuresReply
} from '@swf/generated/types/api/v0/SwHomeGames';

import type { FormData } from '../../Modal/hooks/useForceUpdate';

export interface FormValues extends FormData {
  gameName: string;
  startDate: string;
  startTime: string;
  repeat: boolean;
  repeatDate: string;
  notes: string;
  handType: GameStructure['handType'];
  potStruct:
    | 'STRUCT_NOT_DEFINED'
    | 'STRUCT_LIMIT'
    | 'STRUCT_POT_LIMIT'
    | 'STRUCT_NO_LIMIT'
    | 'STRUCT_POT_NO_LIMIT'
    | 'STRUCT_MULTI_GAME_MIXED';
  tableSize: number;
  currency: Currency | string;
  buyIn: string;
  startingChips: number;
  payout: string;
  tournFormat: string;
  tournLateRegLevel: number;
  levelLength: number;
  tournReentry: number;
  tournSyncBreaks: boolean;
  enableVideoChat: boolean;
  countTowardsClubStandings: boolean;
}

export interface Form {
  form: FormApi<FormValues>;
}

export enum ModalPages {
  'MainInfo',
  'GameDetails',
  'MoreDetails'
}

export enum ModalPagesRoutes {
  '#create-tournament-flow.main-info',
  '#create-tournament-flow.game-details',
  '#create-tournament-flow.more-details'
}

export const totalPages = Object.keys(ModalPages).length / 2 - 1;

export const ModalPagesNames = Object.values(ModalPages).filter((val) => isNaN(Number(val)));

export interface TournamentWizardContext {
  tournamentStructuresResponse: {
    data: HGGetClubTournStructuresReply;
  };
  createClubTournamentResponse: {
    data: HGCreateClubTournamentReply;
    error: string;
  };
  loading: boolean;
}
